import React, { Component } from 'react';
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux"
import classNames from 'classnames';
import agent from '../agent'
import { store, history } from '../store/configureStore'
import { push } from 'react-router-redux';
import Aux from './AuxContainer'
import AMLogo from '../assets/images/audition-magic-favicon.png';
// import GeneralForm from '../components/GeneralForm'
import General from '../components/register/General'
import ProfileForm from '../components/ProfileForm'
import RepresentationForm from '../components/RepresentationForm'
import UploadImageForm from '../components/UploadImageForm'
import FinishRegistrationForm from '../components/FinishRegistrationForm'
import Modal from 'react-responsive-modal';

const ErrorMessage = ({message, flag, token}) => {
	// const url = 'https://casting.auditionmagic.com/ForgotPassword.aspx'
	const url = '/forgotpassword' //forgotpassword
	
	if (flag) {
		return (<div className="margin-bottom-here">You are unable to create a profile with this email and contact information, because a User already exists in the system with the same information, please
				<b><Link to={{
						 pathname: 'artist/login',
						 search: '?token=' + token
					}}>&nbsp;Login</Link></b> or 
				<b><a href={url} target="_blank">
					&nbsp;click here if you forgot your password</a></b>
			</div>)
	} else {
		return (<div className="margin-bottom-here">{ message }</div>)
	}
}

class AgencyTalentRegistration extends Component {
	state = { 
		page: 1, 
		redirect: false,
		ageCategory: 'adult',
		termsOfUse: false,
		enableButton: false,
		showModal: false,
		errorMessage: ''
	}

  componentWillUnmount() {
  	this.props.onUnload()
  }

  componentWillReceiveProps(nextProps) {
  	const projectId = new URLSearchParams(this.props.location.search).get('project');
  	const token = new URLSearchParams(this.props.location.search).get('token');
  	const { redirectTo, artist } = nextProps
	console.log('componentWillReceiveProps1',nextProps);
  	if (artist && artist.meta) {
  		const clientToken = localStorage.getItem('jwt') && JSON.parse(localStorage.getItem('jwt'))
			if (!clientToken) {
				agent.setToken(artist.meta);
			}
  	}

  	if (redirectTo && projectId) {
  		this.setState({
  			redirect: true,
  			artist: artist,
  			clientDetails: this.props.location.state
  		})
  	} else if (redirectTo && token) {
  		this.setState({
  			redirect: true,
  			artist: artist,
  			clientDetails: this.props.location.state
  		})
  	}else if (redirectTo) {
			console.log('componentWillReceiveProps',nextProps);	
			store.dispatch(push(redirectTo))
			this.props.onRedirect();
		}
	}

	onChangeAgeCategory = (values) => {
		this.setState({
			ageCategory: values
		})
	}

  nextPage = () => {
	  	this.setState({
			page: this.state.page + 1 })
	}

	previousPage = () => {
		this.setState({
	  		page: this.state.page - 1 })
	}

	onOpenModal = () => {
	    this.setState({ showModal: true });
	  }
	  
	  onCloseModal = () => {
	    this.setState({ showModal: false });
	    history.push({
	      pathname: '/artist/login',
	      search: this.props.location.search,
	      state: this.props.location.state
	    })
	  }

	submit = (values, dispatch, props) => {
		console.log('>>RegistrationForm', values, this.props);
		const projectId = new URLSearchParams(this.props.location.search).get('project');
		const token = new URLSearchParams(this.props.location.search).get('token');
		const project = this.props.location.state ? this.props.location.state.projectId : null
		const creator_id = this.props.location.state ? this.props.location.state.agency.meta.id : null
		const ageCategory = values.artist.ageCategory.split(',')[0]
		console.log('submit-artistregistercontainer', this.props, creator_id, ageCategory)
		let params = {
			artist: {
				first_name: values.artist.first_name,
					last_name: values.artist.last_name,
					username: values.artist.username ? values.artist.username : values.artist.email,
					email: values.artist.email,
					password: values.artist.password,
					gender: values.artist.gender,
					mobile_number: values.artist.mobile_number,
					state: values.artist.state,
					country: values.artist.country,
					company_id: this.props.company_id,
					creator_id: creator_id,
					artist_type: 'represented',
					project_id: projectId || "",
					avatar: values.photo,
					active_avatar: "",
					statistics: "{}"
			}
		}

		if (ageCategory === 'adult') {
			params.artist.age_from = values.artist.age_from
			params.artist.age_to = values.artist.age_to
		} else {
			params.artist.birth_date = values.artist.birth_date
		}

		const getFormData = (object, namespace) => Object.keys(object).reduce((formData, key) => {	
			let formKey = namespace ? `${namespace}[${key}]` : key
			formData.append(formKey, object[key])
			return formData
		}, new FormData());

		//console.log('submit-registration', getFormData(params.artist, 'artist'))
		// setTimeout(() => {
			//agent.Artist.finalizeFiles(artist_id).then(({result}) => { this.setState({enableNextButton: true}) } )
			if (projectId) {
				this.props.clientRegisterArtist(getFormData(params.artist, 'artist'), projectId)
					.then((res) => { 
						this.setState({ enableButton: true, showModal: this.props.error, errorMessage: this.props.error.errors[0] });
					 })
					.catch((error) => { this.setState({ enableButton: true, showModal: true }) });	
			} else {
				let formD = getFormData(params.artist, 'artist')
				console.log('submit-registration', formD)
				this.props.registerArtist(formD)
					.then((res) => { 
						this.setState({ enableButton: true, showModal: this.props.error, errorMessage: this.props.error.errors[0] });
						//this.props.onFailed();
					})
					.catch((error) => { this.setState({ enableButton: true, showModal: true }) });
			}
		// }, 1000)
		
	}

	onAddAnother = () => {
		console.log('onAddAnother', this.props)
		this.props.updateToggleAdd(true)
	}

	render() {
		const { location } = this.props
		const { page, errorMessage } = this.state
		console.log('render-agencyregistration', this.props)
		const projectId = new URLSearchParams(location.search).get('project');
		const token = new URLSearchParams(location.search).get('token');
		const project = location.state ? location.state.projectId : null
		//const hidRepresent = project ? token ? project.public_skip_agency : project.skip_agency : false
		const hidRepresent = true
		console.log('render-register', this.props)
		const labels = {
			country_label: 'To get started, please select the country, category and agree to terms below, on behalf of your talent.',
			adult: 'Talent is 18+ years of age (Adult)',
			minor: 'Talent is under 18 years of age (Minor)',
			agreed: 'I have read and agree to the site terms of use on behalf of this talent'
		}
		//if (true) {
		if ((token || projectId) && this.state.redirect) {
			return (
				<div>
					<section className="gray-bg section artist-success-registration">
						<div className="row">
						<div className="small-12 medium-6 medium-centered text-center columns">
							<h5 className="text-center loading-text">You have successfully added this talent to your Agency. Use the options below to add another or finish</h5>

							<button className="button primary" onClick={this.onAddAnother}>ADD ANOTHER</button>
							<button className="button primary">FINISH</button>

						</div>
						</div>
					</section>
				</div>
			)
		}

		return (
			<div>
				<Modal classNames={{ modal: 'small-modal' }} open={this.state.showModal} onClose={this.onCloseModal} little>
		          <h2 className="reveal-title">Error occured</h2> 
		          
		          <ErrorMessage message={this.state.errorMessage} flag={this.state.errorMessage === 'Loginname duplicated'} token={token} />
		          
		          <div className="clearfix"></div>
		          <button className="button float-left" onClick={this.onCloseModal}>Close</button>
		    	</Modal>
				
				<section id="artist-essentials" className="section-artist-essentials gray-bg">
					<div className={classNames('grid-x', 'align-center', 'text-center', 'adjust-padding')}>
						<div className="small cell small-10 medium-10 large-6 cell">
							<ul className="tabs menu steps steps-customs expanded" data-tabs>
								<li className={classNames("tabs-title", {'columnli':  true}, {'is-active' : page >= 1})}>
								  	<div className="step-num">1</div>
							        <div className="step-name">General</div>
							  </li>
							  <li className={classNames("tabs-title", {'columnli':  true}, {'is-active' : page >= 2})}>
								  	<div className="step-num">2</div>
							        <div className="step-name">Create Profile</div>
							  </li>
							  {
							  	hidRepresent ? <div></div> :
								  <li className={classNames("tabs-title", {'columnli':  true}, {'is-active' : page >= 3}, {'showli' : page === 3 || page <= 3}, {'hideli' : page !== 3})}>
										<div className="step-num">3</div>
								        <div className="step-name">Representation</div>
								  </li>
							  }
							  <li className={classNames("tabs-title", {'columnli':  true}, {'is-active' : page >= 4}, {'showli' : page === 4}, {'hideli' : page !== 4})}>
									<div className="step-num">{hidRepresent ? 3 : 4}</div>
							        <div className="step-name">Profile Image</div>
							  </li>
							  <li className={classNames("tabs-title", {'columnli':  true}, {'is-active' : page >= 5}, {'showli' : page === 5}, {'hideli' : page !== 5})}>
									<div className="step-num">{hidRepresent ? 4 : 5}</div>
							        <div className="step-name">Finish</div>
							  </li>
							</ul>
						</div>
					</div>
				</section>
						

	        	{page === 1 && <General 
	        		
	        		onSubmit={this.nextPage} labels={labels} />}

	        	{page === 2 && (
	        		<ProfileForm 
	        			projectId={projectId}
	        			previousState={location.state}
	        			ageCategory={this.state.ageCategory}
	        			previousPage={this.previousPage}
	        			location={location}
	        			onSubmit={this.nextPage} />
	        	)}

	        	{page === 3 && (
		          <RepresentationForm
		            previousPage={this.previousPage}
		            onSubmit={this.nextPage}
		            hidRepresent={hidRepresent}
		            location={location}
		          />
		        )}

		        {page === 4 && (
		          <UploadImageForm
		            previousPage={this.previousPage}
		            onSubmit={this.nextPage}
		          />
		        )}

		        {page === 5 && (
		          <FinishRegistrationForm
		            previousPage={this.previousPage}
		            enableButton={this.state.enableButton}
		            onSubmit={this.submit}
		          />
		        )}

			</div>
		)
	}
}

const mapStateToProps = state => ({
	...state.auth,
	...state.common,
	...state.artist
})
const mapDispatchToProps = (dispatch) => ({
	onUnload: () => 
		dispatch({ type: 'REGISTER_PAGE_UNLOADED' }),
	clientRegisterArtist: (artist, projectId)	=> 
		dispatch({ 
			type: 'CLIENT_REGISTER_ARTIST', 
			payload: agent.Artist.register(artist),
			projectId
		}),
	registerArtist: artist =>
		dispatch({ type: 'REGISTER_ARTIST', payload: agent.Artist.register(artist) }),
  onRedirect: () =>
    dispatch({ type: 'REDIRECT' }),
  onFailed: () =>
    dispatch({ type: 'FAILED' })
})
export default connect(mapStateToProps, mapDispatchToProps)(AgencyTalentRegistration)


// WEBPACK FOOTER //
// ./src/containers/AgencyTalentRegistration.js